export default {
  getCategoryDetails: (state) => state.categories.details.data,
  getCategoryDetailsIsFetching: (state) => state.categories.details.isFetching,

  getCategories: (state) => state.categories.list.items,
  getCategoriesIsFetching: (state) => state.categories.list.isFetching,
};
